import React from 'react';
import { UserPlus, Video, FileSignature, Truck } from 'lucide-react';

export const HowItWorks: React.FC = () => {
  const steps = [
    {
      icon: UserPlus,
      title: "Create Profile",
      desc: "Download the app and set up your encrypted health profile in under 2 minutes."
    },
    {
      icon: Video,
      title: "Consult Doctor",
      desc: "Video chat with a licensed physician from the comfort of your home or office."
    },
    {
      icon: FileSignature,
      title: "Get Treatment",
      desc: "Receive a personalized treatment plan and digital prescription instantly."
    },
    {
      icon: Truck,
      title: "Discreet Delivery",
      desc: "Medications delivered to you, or collect from your preferred pharmacy."
    }
  ];

  return (
    <section className="py-24 bg-secondary relative overflow-hidden">
      {/* Background Decor */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-primary/5 via-secondary to-secondary pointer-events-none"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16 space-y-4">
          <div className="inline-block px-3 py-1 bg-white/10 border border-white/10 rounded-full text-xs font-bold text-white uppercase tracking-wider">
            The Process
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            Healthcare Made <span className="text-primary">Simple</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            No waiting rooms, no awkward conversations. Just streamlined professional care.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {/* Connector Line (Desktop) */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-gradient-to-r from-white/5 via-primary/50 to-white/5 border-t border-dashed border-white/20 z-0"></div>

          {steps.map((step, index) => (
            <div key={index} className="relative z-10 group">
              <div className="bg-secondary border border-white/10 p-1 rounded-2xl w-24 h-24 mx-auto mb-6 relative">
                 <div className="w-full h-full bg-white/5 rounded-xl flex items-center justify-center text-white group-hover:bg-primary group-hover:text-white transition-all duration-500 shadow-[0_0_30px_rgba(45,89,240,0.2)]">
                    <step.icon size={32} strokeWidth={1.5} />
                 </div>
                 {/* Number Badge */}
                 <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center font-bold border-4 border-secondary text-sm">
                    {index + 1}
                 </div>
              </div>

              <div className="text-center px-2">
                <h3 className="text-xl font-bold text-white mb-3">{step.title}</h3>
                <p className="text-sm text-gray-400 leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};